import type { RefOrGetter } from "ls/common/types";
import { useIsModPressed } from "ls/composables/useIsModPressed";
import { openUrl } from "ls/features/disko/links/openUrl";
import { computed, toValue } from "vue";

export function useLinkNodeClick(readonly: RefOrGetter<boolean>, url: RefOrGetter<string | undefined>) {
  const isModPressed = useIsModPressed();

  function handleLinkClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    const shouldOpen = toValue(readonly) || isModPressed.value;
    if (!shouldOpen) return;

    const href = toValue(url);
    if (!href) return;

    void openUrl(href);
  }

  function handleWellKnownInlineCardClick(event: MouseEvent) {
    // let links work as usual in the case when the text editor is in readonly mode
    if (toValue(readonly)) return;

    // prevent default link behavior when Meta or Control not pressed
    // toggle toolbar instead
    if (!isModPressed.value) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.stopPropagation();
    }
  }

  const isPointer = computed(() => toValue(readonly) || isModPressed.value);

  return {
    isPointer,
    handleLinkClick,
    handleWellKnownInlineCardClick,
  };
}
